export default {
  headers: {
    addTitle: 'ALTA Y EMISION',
    newInvoice: 'Nueva factura',
    newSelfInvoice: 'Nueva autofactura',
    proForm: 'Proforma (quedará oculto)',
    import: 'Importar',
    pendingInvoices: 'Facturas sin emitir',
    pendingAutoinvoices: 'Autofacturas pendientes de emisión',
    newThirdParty: 'Nuevo suplido',
    pendingThirdParty: 'Suplidos sin emitir',
    searcher: 'BUSCADOR',
    searcherOld: 'BUSCADOR ANTIGUAS',
    emittedTitle: 'EMITIDAS/RECIBIDAS',
    provider: 'Proveedor',
    payer: 'Pagador',
    financing: 'Financiación',
    configTitle: 'CONFIGURACION',
    generalData: 'Datos generales',
    notification: 'Notificación',
    keys: 'Claves',
    catalog: 'Catálogo',
    format: 'Formato factura',
    agenda: 'AGENDA',
    stats: 'ESTADÍSTICAS',
    thirdParty: 'Suplidos',
    thirdPartyWithoutIssued: 'Suplidos y terceros pendientes de emisión'
  },
  summary: 'Resumen'
}
